import React from 'react';
import { FlowNode } from '../../../../types/flowBuilder';
import { BaseConfigProps, ConfigSection, ConfigField } from '../shared/ConfigFormHelpers';

interface MergeConfigProps extends BaseConfigProps {
  node: FlowNode;
  updateConfig: (key: string, value: any) => void;
}

const MergeConfig: React.FC<MergeConfigProps> = ({ node, updateConfig }) => {
  return (
    <div className="space-y-4">
      <ConfigSection title="Egyesítés beállítások">
        <ConfigField
          label="Egyesítési mód"
          description="Hogyan egyesítse az adatokat"
        >
          <select
            value={node.data.config?.mergeMode || 'waitAll'}
            onChange={(e) => updateConfig('mergeMode', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          >
            <option value="waitAll">Várjon minden ágra (AND)</option>
            <option value="waitAny">Első beérkező (OR)</option>
            <option value="waitN">Várjon N ágra</option>
          </select>
        </ConfigField>

        {node.data.config?.mergeMode === 'waitN' && (
          <ConfigField
            label="Várakozás N ágra"
            description="Hány ág beérkezésére várjon"
          >
            <input
              type="number"
              value={node.data.config?.waitForN || 2}
              onChange={(e) => updateConfig('waitForN', parseInt(e.target.value))}
              min="1"
              max="10"
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
            />
          </ConfigField>
        )}

        <ConfigField
          label="Adatok kombinálása"
          description="Hogyan kombinálja a bejövő adatokat"
        >
          <select
            value={node.data.config?.combineMode || 'merge'}
            onChange={(e) => updateConfig('combineMode', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          >
            <option value="merge">Objektumok egyesítése</option>
            <option value="array">Tömbbe gyűjtés</option>
            <option value="first">Első megtartása</option>
            <option value="last">Utolsó megtartása</option>
          </select>
        </ConfigField>

        <ConfigField
          label="Timeout (másodperc)"
          description="Maximum várakozási idő (0 = végtelen)"
        >
          <input
            type="number"
            value={node.data.config?.timeout || 0}
            onChange={(e) => updateConfig('timeout', parseInt(e.target.value))}
            min="0"
            max="3600"
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          />
        </ConfigField>

        <div className="flex items-center">
          <input
            type="checkbox"
            id="continueOnTimeout"
            checked={node.data.config?.continueOnTimeout || false}
            onChange={(e) => updateConfig('continueOnTimeout', e.target.checked)}
            className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
          />
          <label htmlFor="continueOnTimeout" className="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Folytatás timeout esetén a már beérkezett adatokkal
          </label>
        </div>
      </ConfigSection>

      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-md p-3">
        <div className="text-xs text-blue-700 dark:text-blue-300">
          <strong>💡 Használat:</strong>
          <br />• Több párhuzamos ág eredményét egyesíti
          <br />• <strong>waitAll:</strong> Minden ágra vár (pl. párhuzamos API hívások)
          <br />• <strong>waitAny:</strong> Első beérkező (pl. versenyeztetés)
          <br />• <strong>waitN:</strong> N db ág beérkezésére vár
        </div>
      </div>
    </div>
  );
};

export default MergeConfig;
